
import React, { useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

function GroomingForm() {
  
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    address: "",
    breedname: "",
    age: "", 
    gender: "",
    service: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        createdAt: serverTimestamp(), // Firestore Timestamp
        createdAtDate: new Date(),    // Plain JS Date for Excel
      });
      alert("Message submitted successfully!");
      setFormData({ name: "", mobile: "", address: "", breedname: "", age: "", gender: "", service: "" });
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to save data.");
    }
  };

  return (
    <div style={{margin:"0px", padding:"17px"}} className="card">
      <center> <h3 style={{color:"#610045ff"}}><b> BOOK FOR GROOMING</b></h3></center>
    <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
      <input className="mb-2"
        type="text"
        name="name"
        placeholder="Name"
        value={formData.name}
        onChange={handleChange}
        required
      />
      <input className="mb-2"
        type="mobile"
        name="mobile"
        placeholder="Mobile Number"
        value={formData.mobile}
        onChange={handleChange}
        required
      />
         <input className="mb-2"
        type="breedname"
        name="breedname"
        placeholder="Breed Name"
        value={formData.breedname}
        onChange={handleChange}
        required
      />
       <input className="mb-2"
        type="age"
        name="age"
        placeholder="Age"
        value={formData.age}
        onChange={handleChange}
        required
      />
       <input className="mb-2"
        type="gender"
        name="gender"
        placeholder="Male/Female"
        value={formData.gender}
        onChange={handleChange}
        required
      />
      <textarea
        name="service"
        placeholder="Type Servies :-Example- Pawfect Groomers, Fluffy & Fresh, SparklePaws, Snip & Wag, FurryTales Grooming, The Pet Spa, PurePaws Grooming, Elite Pet Care, Groom & Glow, Velvet Paws Studio"
        value={formData.service}
        onChange={handleChange}
        required
      />
      <textarea
        name="address"
        placeholder="Address"
        value={formData.address}
        onChange={handleChange}
        required
      />
      <center>
      <button className="groomingbutton mt-2" type="submit">Submit</button>
      </center>
    </form>
    </div>
  );
}

export default GroomingForm;